<div [dir]="languageDir">
    <router-outlet *ngIf="showContent"></router-outlet>
    <app-confirmation></app-confirmation> 
</div>


